import { createSelector } from "reselect";

const cpCompanyListSelector = state => state.cp.companyList;

export const isLoadingSelector = createSelector(
	cpCompanyListSelector,
	state => state.isLoading
);
export const isNoItemsSelector = createSelector(
	cpCompanyListSelector,
	state => state.isNoItems
);
export const scrollSelector = createSelector(
	cpCompanyListSelector,
	state => state.scroll
);
export const searchSelector = createSelector(
	cpCompanyListSelector,
	state => state.search
);
export const itemsSelector = createSelector(
	cpCompanyListSelector,
	state => state.items
);
